export default __webpack_public_path__ + "static/media/lechera_mix.60855eac.png";